const content = `<p>The Interpreter design pattern is a specific case of <a href="/composite">Composite</a> pattern where the composite structure is used to process an input.</p>

<p>A typical example from the GoF book is a regex processor. The composite structure represents the regex, and the input is a string. Each element in the composite structure analyses a part of the input string, and as a whole the composite structure determines if the string matches the regex.</p>`

export default content
